




























































import { Component, Vue, Prop } from "vue-property-decorator";
import Button from "../../components/Button.vue";
import SingleTeam from "../../components/SingleTeam.vue";
import CreateTeam from "./CreateTeam.vue";
import { getImgUrl, teamData } from "../../utils/dummy";
import { Getter, Action } from "vuex-class";
import { namespaced, NS_ADMIN } from "../../store/namespace";
import { TEAMS } from "../../store/getters.names";
import { FlatTeam } from "../../store/store.types";
import { FETCH_TEAMS } from "../../store/actions.names";
import debounce from "debounce";
@Component({
  name: "teams",
  components: {
    Button,
    SingleTeam,
    CreateTeam
  }
})
export default class TeamOverview extends Vue {
  showModal: boolean = false;
  @Getter(namespaced(NS_ADMIN, TEAMS)) [TEAMS]!: FlatTeam[];
  @Action(namespaced(NS_ADMIN, FETCH_TEAMS)) fetchTeams: any;

  search = debounce(e => {
    this.fetchTeams({ search: e.target.value });
  }, 300);

  mounted() {
    this.fetchTeams();
  }

  removeBatch(){
    this.fetchTeams();
  }
}
